import React from 'react';
import { useTranslate } from 'react-redux-multilingual'

const CorrespondenceFieldInput = (props) => {
    const t = useTranslate();
    
    return(
        <>
            {(props.isFor=='client' && props.index!=0 && (props.sectionField=='type' || props.sectionField=='mode_reglement' || props.sectionField=='newsletter')) ?
                <select 
                    disabled={props.index==0 || props.validButton} 
                    value={props.inputValue.value1} 
                    className='form-control form-control-sm' 
                    onChange={(e)=>props.handleChangeCorrespondenceField(e,'value1')}
                >
                    <option value="">-- Select --</option>
                    {props.sectionField=='newsletter' ? 
                        <>
                            <option value="oui">{t('btnYes')}</option>
                            <option value="non">{t('btnNo')}</option>
                        </>
                    :
                    props.sectionField=='mode_reglement' ? 
                        <>
                            <option value="comptant">{t('cashPayment')}</option>
                            <option value="7days">{t('days7Payment')}</option>
                            <option value="15days">{t('days15Payment')}</option>
                            <option value="30daysFixed">{t('days30PaymentFixed')}</option>
                            <option value="30days">{t('days30Payment')}</option>
                            <option value="45days">{t('days45Payment')}</option>
                            <option value="60days">{t('days60Payment')}</option>
                            <option value="90days">{t('days90Payment')}</option>
                        </>
                    :
                    <>
                        <option value="Local">Local</option>
                        {
                            props.allClientType.map(clientType=>{
                                return(
                                    <option key={clientType.client_type} value={clientType.client_type} >{clientType.client_type}</option>
                                )
                            })
                        }
                    </>
                    }
                </select>
            :   
                <input 
                    disabled={props.index==0 || props.validButton} 
                    value={props.inputValue.value1} 
                    type="text" 
                    className='form-control form-control-sm' 
                    onChange={(e)=>props.handleChangeCorrespondenceField(e,'value1')}
                />
            }
        </>
    )
}

export default CorrespondenceFieldInput;